// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"233":"template","242":"project","930":"task"}[chunkId] || chunkId) + "." + {"44":"7468be48","66":"7b4c3cd6","233":"fb48f14f","242":"33a3b1b7","930":"41e03585"}[chunkId] + ".css";
};